export function num(v) {
  if (v === null || v === undefined || v === "") return "—";
  return Number(v).toLocaleString("en-US");
}

export function money(v, currency = "USD") {
  if (v === null || v === undefined) return "—";
  try {
    return Number(v).toLocaleString("en-US", { style: "currency", currency, maximumFractionDigits: 0 });
  } catch (e) {
    return `${currency} ${Math.round(v).toLocaleString("en-US")}`;
  }
}

export function dateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export function day(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

export function ago(iso) {
  if (!iso) return null;
  const mins = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (Number.isNaN(mins)) return null;
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const h = Math.round(mins / 60);
  if (h < 48) return `${h} h ago`;
  return `${Math.round(h / 24)} days ago`;
}

/** Older than this many hours = shown in amber. */
export function isStale(iso, hours = 26) {
  return !iso || Date.now() - new Date(iso).getTime() > hours * 3600 * 1000;
}
